// import Navbar from "./Nav_bar";
import './Edit_profile.css'
import axios from "axios";
import React, { useState, useEffect } from "react";
import Volunteer_Navbar from '../Search_details/Volunteer_Navbar';
import { useNavigate } from 'react-router-dom';
import Volunteer_Header from '../Search_details/Volunteer_Header';
import validation from './validation_editprofile';
import { NotificationManager} from 'react-notifications';
import LoadingSpinner from '../Utils/LoadingSpinner'
import { toast } from 'react-toastify';
function Edit_profile() {

    const [jobfair_banner_flag,setJobFair_banner_flag] = useState(false);
    const [loader,setLoader] = useState(true);

    let navigate = useNavigate();
      const [profile, setProfile] = useState({
        V_companyname: "",
        V_jobfair: "",
        id: "",
        name:{
            first_name: null,
            email: null,
            phone: null,
        }
    })

    const [jobfair, setJobfair] = useState([
        {
            "id": "",
            "title": "",
        }
    ]);

    const [company, setCompany] = useState([
        {
            "id": "",
            "CompanyName": ""
        }
    ]);

    const [errors, setErrors] = useState({})


    const volunteer = localStorage.getItem("user");    
    const id = volunteer && JSON.parse(volunteer)[0].id;
   
    useEffect(()=>{  
        const volunteer = localStorage.getItem("user");    
        const id = volunteer && JSON.parse(volunteer)[0].id;
        const lc_jobfair_id = volunteer && JSON.parse(volunteer)[0].V_jobfair;
        if (volunteer === null ) {
            navigate('/Volunteer_login');
            setLoader(false);
        }else{
            axios.get(`https://pl.aspireitacademy.com/volunteer_Details/${id}`).then((response) => {
                getJobFairData(response.data[0]); 
                
            }).catch( (error) => { setLoader(false);})
            if (lc_jobfair_id !== null) {
                axios.get(`https://pl.aspireitacademy.com/jobfaircompany_list/${lc_jobfair_id}`).then((res) => {
                    setCompany(res.data);
                    setLoader(false);
                })
            }else{
                setJobFair_banner_flag(true);
                setLoader(false);
                
            }
        }




    },[])


    // fetch job fair list
    const getJobFairData = (responseData) =>{
      
        axios.get("https://pl.aspireitacademy.com/activejobfairlist").then((response) => {
            setJobfair(response.data);
            setLoader(false);
            if(responseData.V_jobfair){
               
                let flag = false;
                response.data.forEach(element => {
                    if(element.id == responseData.V_jobfair){
                        flag = true;
                    }
                });
                if(!flag) {
                    responseData.V_companyname = undefined;
                }
                    setProfile(responseData) 
            
                }else {
                    setProfile(responseData) 
                }
             
               
                
        })
       
    }

    const handleJob_fair = (event) => {
        
        setProfile({ ...profile, [event.target.name]: event.target.value })
       
        setErrors( { ...errors, [event.target.name]: "" });
        axios.get(`https://pl.aspireitacademy.com/jobfaircompany_list/${event.target.value}`).then((res) => {
                 setCompany(res.data);

        }).catch(function (error) {
            toast.error("Something Went Wrong")  ;
        })
       
  
    }

    const handleCompanylist = (e) => {
        setProfile({ ...profile, [e.target.name]: e.target.value })
        setErrors( { ...errors, [e.target.name]: "" });
    }

    const handleInput = (e) => {

        setProfile({
            ...profile, 
            name:{ 
              ...profile.name,
              [e.target.name]: e.target.value 
            }
          });
          setErrors( { ...errors, [e.target.name]: "" });

    }

    //form handling

    function handleValidation(e) {
        e.preventDefault();

        const validationstatus = validation(profile,)
        if (!validationstatus.status) {
            setErrors(validationstatus.errors);
        }
        else{

            axios.put(`https://pl.aspireitacademy.com/volunteerupdate/${id}`, {
                name__first_name: profile.name.first_name,
                name__email:profile.name.email ,
                name__phone: profile.name.phone ,
                jobfair: profile.V_jobfair,
                company: profile.V_companyname
    
            }).then(res => {
                
                if(res.data.message === "Phone number is already taken"){
                    toast.error("Email or Phone number is already exist!")
                }
                else if (res.data === "Email is already taken"){
                    toast.error("Email is already exist!");
                }
                else if (res.data !== "something went wrong" || res.data !== "Email or Phone number is already exist!"
                || res.data !== "Email is already taken") {
                   localStorage.setItem("user", JSON.stringify(res.data));
                    let user = JSON.parse(localStorage.getItem("user"));
    
            
                  toast.success('Profile Updated Successfully');
                  setTimeout(() => {
                    navigate('/Searchjob_seeker');
                  //  window.location ='/Searchjob_seeker';
                  }, 1000);
                }
                else {
                    toast.error("Email or Phone number is already exist!")
                }
            })   .catch(function (error) {
                toast.error("Something Went Wrong")  ;
            })

          }
    }

    return (
<div className="my-custom-scrollbar my-custom-scrollbar-primary">
<section className="bg-white h-100 w-100">
<Volunteer_Header />
<Volunteer_Navbar />

{/* <label className="Title">Edit Profile</label> */}
{ loader ? <LoadingSpinner />:
<div className="container">
<h4  className='text-start text-capitalize mt-4 ps-2 page-title'>Edit Profile</h4>
<hr className="search_line"></hr>
    <form onSubmit={handleValidation} >
            { jobfair_banner_flag ?
                <div className="alert alert-warning text-center " role="alert">
                Please update Job Fair and Company</div>:''
            }
            
            <div className="row">

            <div className="col-sm-6 m-2">
                
                <label className=" pt-4 fw-bold text-left">Name</label><br/>
                <input 
                    type="text"
                    className="form-control"
                     placeholder="Enter Username" 
                     name="first_name"  
                     onChange={(e)=>{handleInput(e)}}
                     value={profile.name.first_name ? profile.name.first_name:''}
                     />
                     <span  className='errorMsg'>
                     {errors.first_name ? errors.first_name:''}
                     </span>
                
            
                <label className=" pt-4 fw-bold text-left">Email</label><br/>
                <input 
                    type="text" 
                    className="form-control"
                    placeholder="Enter Email ID"
                    name="email" 
                    onChange={(e)=>{handleInput(e)}}
                    value={profile.name.email ? profile.name.email: ''}
                    />
                <span  className='errorMsg'>
                     {errors.email ? errors.email:''}
                </span>
                <label className=" pt-4 fw-bold text-left">Phone </label><br/>
                <input 
                    type="number" 
                    className="form-control"
                    placeholder="Enter Phone Number" 
                    maxLength={10}
                    name="phone" 
                    onChange={(e)=>{handleInput(e)}}
                    value={profile.name.phone ? profile.name.phone: '' }
                     />
                      <span  className='errorMsg'>
                     {errors.phone ? errors.phone:''}
                      </span>
            </div>

            <div className="col-sm m-2">

                <div>
                <label className=" pt-4 fw-bold text-left">Job Fair<span style={{color:"red"}}>*</span> </label>
                <select name="V_jobfair"   onChange={(e) => handleJob_fair(e)}
                value={profile.V_jobfair ? profile.V_jobfair: '' }
                className="form-control"
                >
                    <option value=''>-----select------▼    </option>
                        {   
                           
                            jobfair.map(item => { return (<option value={item.id}  
                                 key={item.id}   >
                                    {item.title}</option>) })
                        }
                </select>
                <span  className='errorMsg'>
                     {errors.V_jobfair ? errors.V_jobfair:''}
                </span>
                </div>

                <div>
                <label className=" pt-4 fw-bold text-left">Company<span style={{color:"red"}}>*</span></label><br/>
                <select name="V_companyname"    
                    onChange={(e) => {handleCompanylist(e)} }
                    className="form-control"
                    value={profile.V_companyname ? profile.V_companyname: '' } >
                     <option value = ''>-----select------▼    </option>
                        {
                            company.map(item => { return (<option 
                                    value={item.id} key={item.id}  
                                    >{item.CompanyName}</option>
                            ) })
                        }

                </select>
                <span  className='errorMsg'>
                     {errors.V_companyname ? errors.V_companyname:''}
                </span>
                </div>
            </div>
            <div  className="m-2" >
            <button type="submit" className="btn btn-primary " id='volsavebtn'>Save</button>

            </div>
        </div>
            
        


    </form>

</div>
}
</section>    
</div>

    );
} export default Edit_profile;